import { useEffect, useState } from 'react';

import { t } from 'i18next';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import styles from './CreateAccount.module.css';
import BubbleButton from '../../components/UI/Buttons/BubbleButton/BubbleButton';
import SocialButton from '../../components/UI/Buttons/SocialButton/SocialButton';
import CreateAccountForm from '../../components/Forms/Signup/CreateAccountForm';
import { setBackButtonLink } from '../../app/features/headerUISlice';
import {
    CheckFilledWhite,
    DisableCheck,
    EmployerEntity,
    HeroSectionBottomRightRock,
    HeroSectionLeftRock,
    HeroSectionTopRightRock,
    JobSeekerEntity,
    lookingForEmployer,
    LookingForEmployerIndividual
} from '../../assets/images/icons';

function ResetPassword() {
    const dispatch = useDispatch();
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 1024);
    const [entityOptions, setEntityOptions] = useState('');
    const [seletectEntity, setSeletectEntity] = useState('');
    const [enabledForm, setEnabledForm] = useState(false);
    const userData = useSelector((state) => state.user.userData);

    useEffect(() => {
        dispatch(setBackButtonLink('/login'));
        return () => {
            dispatch(setBackButtonLink(false));
        };
    }, [dispatch]);
    useEffect(() => {
        const handleResize = () => { setIsLargeScreen(window.innerWidth > 1024); };
        window.addEventListener('resize', handleResize);
        dispatch(setBackButtonLink('/login'));
        return () => {
            window.removeEventListener('resize', handleResize);
            dispatch(setBackButtonLink(false));
        };
    }, [dispatch]);

    const JobSeekerSignUpUI = () => {
        const { t } = useTranslation();

        return (
            <div className={styles.section}>
                <div className={styles.contentContainer}>
                    <div className={styles.girlImageContainer}>
                        <img
                            className={styles.girlImage}
                            style={{objectFit:"contain"}}
                            src={require('../../assets/images/signup/jobseekerGirl.png')}
                        />
                    </div>
                    <div className={styles.girlImageContainerFor1024}>
                        <img
                            className={styles.girlImageFor1024}
                            style={{objectFit:"contain"}}
                            src={require('../../assets/images/signup/girlWithoutPadding.png')}
                        />
                    </div>
                    {isLargeScreen ? (
                        <>
                            <div className={styles.arrowWrapper}>
                                <img
                                    src={require('../../assets/images/signup/bottomRightArrow.png')}
                                    className={styles.arrowContainer}
                                />
                            </div>
                            <p className={styles.heading}>
                                {t('jobSeekerSignUp.heading')}
                            </p>
                            <p className={styles.title}>
                                {t('jobSeekerSignUp.subHeading')}
                            </p>
                            <div className={styles.buttonContainer}>
                                <BubbleButton
                                    dark
                                    headerDarkButton
                                    onClick={() => { setEntityOptions('employer') }}
                                >
                                    {t('jobSeekerSignUp.buttonText')}
                                </BubbleButton>
                            </div>
                        </>
                    ) : (
                        <div className={styles.bodyContainer}>
                            <div className={styles.arrowWrapper}>
                                <img
                                    src={require('../../assets/images/signup/bottomRightArrow.png')}
                                    className={styles.arrowContainer}
                                />
                            </div>
                            <p className={styles.heading}>
                                {t('jobSeekerSignUp.heading')}
                            </p>
                            <p className={styles.title}>
                                {t('jobSeekerSignUp.subHeading')}
                            </p>
                            <div className={styles.buttonContainer}>
                                <BubbleButton
                                    dark
                                    headerDarkButton
                                    onClick={() => { setEntityOptions('employer') }}
                                >
                                    {t('jobSeekerSignUp.buttonText')}
                                </BubbleButton>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };
    const EmployerSignUpUI = () => {
        const { t } = useTranslation();

        return (
            <div className={styles.section}>
                <div className={styles.contentContainer}>
                    <div className={styles.employerImageContainer}>
                        <img
                            className={`${styles.girlImage} ${styles.employerImg}`}
                            style={{objectFit:"contain"}}
                            src={require('../../assets/images/signup/Employer.png')}
                        />
                    </div>
                    <div className={styles.girlImageContainerFor1024}>
                        <img
                            className={styles.girlImageFor1024}
                            style={{objectFit:"contain"}}
                            src={require('../../assets/images/signup/Employer.png')}
                        />
                    </div>
                    {isLargeScreen ? (
                        <div style={{ paddingLeft: '20px' }}>
                            <div className={`${styles.arrowWrapper} ${styles.arrowWrapperEmployer}`}>
                                <img
                                    src={require('../../assets/images/signup/topRightArrow.png')}
                                    className={`${styles.arrowContainer} ${styles.arrowContainerEmployer}`}
                                />
                            </div>
                            <p className={`${styles.heading} ${styles.employerTitle}`}>
                                {t('employerSignUp.heading')}
                            </p>
                            <p className={`${styles.title} ${styles.employerTitle}`}>
                                {t('employerSignUp.subHeading')}
                            </p>
                            <div
                                className={styles.buttonContainer}
                                style={{ justifyContent: 'flex-start' }}
                            >
                                <BubbleButton
                                    onClick={() => { setEntityOptions('jobseeker') }}
                                    headerButton>
                                    {t('employerSignUp.buttonText')}
                                </BubbleButton>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.bodyContainer}>
                            <div className={`${styles.arrowWrapper} ${styles.arrowWrapperEmployer}`}>
                                <img
                                    src={require('../../assets/images/signup/topRightArrow.png')}
                                    className={`${styles.arrowContainer} ${styles.arrowContainerEmployer}`}
                                />
                            </div>
                            <p className={`${styles.heading} ${styles.employerTitle}`}>
                                {t('employerSignUp.heading')}
                            </p>
                            <p className={`${styles.title} ${styles.employerTitle}`}>
                                {t('employerSignUp.subHeading')}
                            </p>
                            <div className={styles.buttonContainer}>
                                <BubbleButton
                                    headerButton
                                    onClick={() => { setEntityOptions('jobseeker') }}
                                >
                                    {t('employerSignUp.buttonText')}
                                </BubbleButton>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };
    const EntityOptionsUI = ({ entityOptions }) => {
        const { t } = useTranslation();

        return (
            <div className={styles.entityWrapper}>
                <div className={styles.backgroundLayer}></div>
                <img src={HeroSectionLeftRock} className={styles.HeroSectionCircle1} alt="Decorative rock on the left in the Hero section" />
                <img src={HeroSectionTopRightRock} className={styles.HeroSectionCircle2} alt="Decorative rock on the top-right in the Hero section" />
                <img src={HeroSectionBottomRightRock} className={styles.HeroSectionCircle3} alt="Decorative rock on the bottom-right in the Hero section" />
                <p className={styles.entityTitle}>{t('EntityOptionsUI.entityTitle')}</p>
                <div className={styles.entityContainer}>
                    <div
                        onClick={() => setSeletectEntity('business')}
                        className={`${styles.entity} ${seletectEntity === 'business' ? styles.selected : styles.notSelected}`}
                    >
                        <img src={entityOptions !== 'jobseeker' ? lookingForEmployer : EmployerEntity} />
                        <p className={`${styles.entityText} ${seletectEntity === 'business' ? styles.selected : styles.notSelected}`}>
                            {entityOptions !== 'jobseeker' ? t('EntityOptionsUI.individualOption.title_for_job_seeker_business') : t('EntityOptionsUI.businessOption.title')}
                        </p>
                        <img src={seletectEntity === 'business' ? CheckFilledWhite : DisableCheck} className={styles.checkIcon} />
                    </div>
                    <div
                        onClick={() => setSeletectEntity('individual')}
                        className={`${styles.entity} ${seletectEntity === 'individual' ? styles.selected : styles.notSelected}`}
                    >
                        <img src={entityOptions !== 'jobseeker' ? LookingForEmployerIndividual : JobSeekerEntity} style={{ margin: '10px' }} />
                        <p className={`${styles.entityText} ${seletectEntity === 'individual' ? styles.selected : styles.notSelected}`}>
                            {entityOptions !== 'jobseeker' ? t('EntityOptionsUI.businessOption.title_for_job_seeker_house_worker') : t('EntityOptionsUI.individualOption.title')}
                        </p>
                        <img src={seletectEntity === 'individual' ? CheckFilledWhite : DisableCheck} className={styles.checkIcon} />
                    </div>
                </div>

                <BubbleButton
                    dark
                    headerDarkButton
                    onClick={() => { if (seletectEntity) { setEnabledForm(true) } }}
                    className={`${styles.joinButton} ${seletectEntity ? styles.joinButtonEnabled : styles.joinButtonDisabled}`}
                >
                    {
                        entityOptions !== 'jobseeker' ?
                            seletectEntity === 'individual'
                                ? t('EntityOptionsUI.individualOption.button_text_for_job_seeker_house_worker')
                                : t('EntityOptionsUI.individualOption.buttonText')
                            :
                            seletectEntity === 'individual'
                                ? t('EntityOptionsUI.individualOption.buttonText')
                                : t('EntityOptionsUI.businessOption.buttonText')}

                </BubbleButton>
            </div>
        );
    };
    return (
        <>
            <Helmet>
                <title>FindCV - Create Account</title>
            </Helmet>
            <div className={styles.container}>
                {

                    enabledForm ?
                        <div className={styles.entityWrapper} style={{ height: "auto", }}>
                            <div className={styles.backgroundLayer}></div>
                            <img src={HeroSectionLeftRock} className={styles.HeroSectionCircle1} alt="Decorative rock on the left in the Hero section" />
                            <img src={HeroSectionTopRightRock} className={styles.HeroSectionCircle2} alt="Decorative rock on the top-right in the Hero section" />
                            <img src={HeroSectionBottomRightRock} className={styles.HeroSectionCircle3} alt="Decorative rock on the bottom-right in the Hero section" />
                            <div className={styles.formContainer}>
                                <p className={`${styles.entityHeading} ${styles.entityTitle}`}>{t('entity.create_account')}</p>
                                {!userData &&
                                    <>
                                        <SocialButton isRegister />
                                        <div className={styles.divider}>
                                            <div className={styles.dividerLine}></div>
                                            <div className={styles.orText}>{t('or')}</div>
                                            <div className={styles.dividerLine}></div>
                                        </div>
                                    </>
                                }
                                <CreateAccountForm
                                    seletectEntity={seletectEntity}
                                    accountType={entityOptions == 'jobseeker' ? 'employer' : 'jobseeker'}
                                    company={seletectEntity == 'business' && entityOptions == 'jobseeker'}
                                />
                            </div>
                        </div>
                        :
                        entityOptions?.length > 0 ?
                            <>
                                <EntityOptionsUI entityOptions={entityOptions} />
                            </>
                            :
                            <>
                                <JobSeekerSignUpUI />
                                <EmployerSignUpUI />
                            </>}
            </div>
            {/* <CreateAccountForm /> */}
        </>
    );
}

export default ResetPassword;